import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(() => ({
  marginBottom: '16px',
  width: '100%',
  position: 'relative',
  overflow: 'visible',
}));

export const AmountAvailableContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: '10px',
}));

export const ProgressBarContainer = styled(Box)(() => ({
  position: 'relative',
  marginBottom: '8px',
  overflow: 'visible',
  width: '100%',
}));

export const ProgressBarBackground = styled(Box)(() => ({
  height: 10,
  width: '100%',
  borderRadius: 100,
  backgroundColor: 'var(--Greyscale-300, #ECEFF0)',
}));

export const DisbursedProgressBar = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  height: 10,
  backgroundColor: theme.palette.primary.light,
  borderTopLeftRadius: 100,
  borderBottomLeftRadius: 100,
}));

export const DrawRequestProgressBar = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  height: 10,
  backgroundColor: theme.palette.teal[500],
  borderTopRightRadius: 100,
  borderBottomRightRadius: 100,
}));

export const ProgressLabel = styled(Box)(() => ({
  position: 'absolute',
  top: -22,
  transform: 'translateX(-50%)',
  whiteSpace: 'nowrap',
}));

export const ProgressPercentage = styled('span')(({ theme }) => ({
  color: theme.palette.green[500],
  fontWeight: 700,
}));

export const FooterContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '16px',
}));
